import { getData, postData, putData } from "./rest-api-helper"

export async function getAllShipmts({ limit, pageNumber, searchKeyWord, searchType, order, time, fromDate, toDate, withBalance }) {
    const details = {
        urlPath: "/shipment",
        queryParams: {
            user: 'bo',
            time: time,
            ...(searchKeyWord && { searchKeyWord }),
            ...(searchType && { searchType }),
            order,
            limit,
            offset: (pageNumber * limit) - limit,
            includeTotal: 1,
            ...(fromDate && { fromDate }),
            ...(toDate && { toDate }),
            ...(withBalance && { withBalance: 1 }),
        }
    }
    const res = await getData(details);
    return {
        totalLength: res?.totalCount ?? 0,
        data: res?.result ?? []
    }
}

export async function createShipmt(data) {
    const details = {
        urlPath: "/shipment",
        body: {
            ...data
        }
    }

    const res = await postData(details);
    return res;
}

export async function getSingleShipmt(shipmtId) {
    const details = {
        urlPath: "/shipment/getSingle/" + shipmtId
    }

    const res = await getData(details);
    return res;
}


export async function putShipmtStatus({ shipmtId, currStatus, cancelRemarks }) {
    const details = {
        urlPath: `/shipment/updateStatus`,
        queryParams: {
            shipmtId, currStatus
        },
        body: {
            cancelRemarks
        }
    }

    const res = await putData(details);
    return res;
}

export async function putShipmt({ shipmtId, body }) {
    const details = {
        urlPath: `/shipment/editData/${shipmtId}`,
        body: {
            ...body
        }
    }

    const res = await putData(details);
    return res;
}

export async function putFeedback({ shipmtId, body }) {
    const details = {
        urlPath: `/shipment/feedback/${shipmtId}`,
        body: {
            ...body
        }
    }

    const res = await putData(details);
    return res;
}


export async function sendDataInvalid({ body }) {
    const details = {
        urlPath: `/shipment/dataInvalid`,
        body: {
            ...body
        }
    }

    const res = await postData(details);
    return res;
}

export async function getAllShipmtRepts({ fromDate, toDate, picLoc, delLoc, shipmtTime, status, cust, trkOp, trkRegNo, mat, order, limit, pageNumber,
    cnorNames, cneeNames }) {

    let queryParamsObj = {
        fromDate, toDate, picLoc, delLoc, shipmtTime, status, cust, trkOp, trkRegNo, mat, order,
        ...(cnorNames?.length && { cnorNames }),
        ...(cneeNames?.length && { cneeNames })
    }

    const details = {
        urlPath: "/shipment/shipmtReports",
        queryParams: {
            ...queryParamsObj,
            limit,
            offset: (pageNumber * limit) - limit,

        }
    }
    let data = await getData(details);
    let res = data?.result || (Array.isArray(data) ? data : []);
    const normalizedData = (res || []).map(row => ({
        ...row,

        shipmtId: row.shipmtId ?? row.shipmentId
    }));

    // const details2 = {
    //     urlPath: "/shipment/shipmtReports",
    //     queryParams: {
    //         ...queryParamsObj,
    //         limit: 100000000000000,
    //         offset: 0,
    //     }
    // }
    // let res2 = await getData(details2);

    return {
        totalLength: data?.count || (Array.isArray(data) ? data.length : 0),
        data: normalizedData
    }
}

export async function postCombinedShipmts({ shipments }) {
    const details = {
        urlPath: "/shipment/combined",
        body: { shipments }
    }
    const res = await postData(details);
    return res;
}

export async function putBulkShipmtStatus({ shipmtIds, currStatus, cancelRemarks }) {
    const details = {
        urlPath: "/shipment/bulkStatus",
        body: { shipmtIds, currStatus, cancelRemarks }
    }
    const res = await putData(details);
    return res;
}

export async function getCustLedger({ custId, fromDate, toDate }) {
    const details = {
        urlPath: "/shipment/custLedger",
        queryParams: { custId, fromDate, toDate }
    }
    const res = await getData(details);
    return res || { broughtForward: 0, rows: [] };
}

export async function postCustPymt({ shipmtId, body }) {
    const details = {
        urlPath: `/shipment/custPymt`,
        body: {
            shipmtId,
            ...body
        }
    }

    const res = await postData(details);
    return res;
}

export async function getCustShipmts({ limit, pageNumber, order, time, custId }) {
    let queryParamsObj = {
        custId,
        time: time,
        order
    }

    const details = {
        urlPath: "/shipment/byCust",
        queryParams: {
            ...queryParamsObj,
            limit,
            offset: (pageNumber * limit) - limit,

        }
    }
    let res = await getData(details);

    const details2 = {
        urlPath: "/shipment/byCust",
        queryParams: {
            ...queryParamsObj,
            limit: 1000,
            offset: 0,
        }
    }
    let res2 = await getData(details2);

    return {
        totalLength: res2 ? res2?.length : 0,
        data: res ? res : []
    }
}


export async function getTrkOpShipmts({ limit, pageNumber, order, time, trkOpId }) {
    let queryParamsObj = {
        trkOpId,
        time: time,
        order
    }

    const details = {
        urlPath: "/shipment/byTrkOp",
        queryParams: {
            ...queryParamsObj,
            limit,
            offset: (pageNumber * limit) - limit,

        }
    }
    let res = await getData(details);

    const details2 = {
        urlPath: "/shipment/byTrkOp",
        queryParams: {
            ...queryParamsObj,
            limit: 1000,
            offset: 0,
        }
    }
    let res2 = await getData(details2);

    return {
        totalLength: res2 ? res2?.length : 0,
        data: res ? res : []
    }
}

export async function getConEwbShipmts({ trkOpReqId }) {
    const details = {
        urlPath: `/shipment/getConEwbShipmts/${trkOpReqId ? trkOpReqId : 1}`,
    }

    const res = await getData(details);
    return res ? res : [];
}

export async function putShipmtPricing({ body }) {
    const details = {
        urlPath: `/shipment/shipmtPricing`,
        body: {
            ...body
        }
    }

    const res = await putData(details);
    return res;
}
export async function getConsolidatedBreakup({ truckOpReqId }) {
    //console.log("📤 API called with:", truckOpReqId);
    const details = {
        urlPath: `/shipment/consolidated-breakup/${truckOpReqId}`,
    }

    const res = await getData(details);

    return res || [];
}
